module.exports = __webpack_public_path__ + "static/media/MERS-GSE139516.0fac9363.csv";